import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  AppBar,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Box,
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  ListItem,
} from "@mui/material";
// import { TreeView, TreeItem } from "@mui/lab";

import { useDispatch, useSelector } from "react-redux";
import {
  AssignmentInd,
  Business,
  Dashboard,
  DeveloperBoard,
  FormatAlignCenter,
  Group,
  ListAlt,
  PinDrop,
  WebAsset,
} from "@mui/icons-material";
import { commonCss } from "../../StyleConfig/CommonCss";
import { companyInfo, roleInfo } from "../../Pages/API/config";

const MenuUI = ({ item, bg }) => {
  const icon = {
    Dashboard: Dashboard,
    ListAlt: ListAlt,
    Group: Group,
    DeveloperBoard: DeveloperBoard,
    PinDrop: PinDrop,
    Business: Business,
  };
  const Icon = icon[item.icon];
  return (
    <ListItem sx={{ background: bg ? commonCss.yellow : "none" }}>
      <Link to={item.link}>
        <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
          <Icon />
          <Typography>{item.name}</Typography>
        </Box>
      </Link>
    </ListItem>
  );
};

const SideNav = (props) => {
  const navigate = useNavigate();
  // const currentPath="/"+window.location.href.split("/")[3]
  const currentPath = window.location.pathname;
  const dispatch = useDispatch();

  const [listOpen, setListOpen] = useState({});

  const drawerOpen = useSelector((state) => state.data.drawerOpen);
  const login = useSelector((state) => state.auth.loginInfo);
  const menuList = useSelector((state) => state.auth.menuList);
  console.log(menuList);
  const loginRoldId = String(login.roleIds).split(",");
  const admin = loginRoldId.includes(roleInfo.admin);
  const psUser = login.companyId === companyInfo.ps;
  const OEController =
    loginRoldId.includes(roleInfo.oe) ||
    loginRoldId.includes(roleInfo.controller);
  const remainingRole = [
    roleInfo.contractStaff,
    roleInfo.HSSE,
    roleInfo.admin,
    roleInfo.agt,
    roleInfo.engineer,
    roleInfo.pi,
    roleInfo.liftingInspector,
    roleInfo.lpi,
    roleInfo.sme,
    roleInfo.technican,
    roleInfo.operationManager,
    roleInfo.isolationOwner,
    roleInfo.isolationVerifier,
  ];
  const getFormMenu = loginRoldId.filter((fil) => {
    const getMenu = remainingRole.filter((fill) => fill === fil);
    if (getMenu.length !== 0) {
      return true;
    } else {
      return false;
    }
  });

  const handleClick = (listType) => {
    setListOpen({ ...listOpen, [`${listType}`]: !listOpen[`${listType}`] });
  };

  const handleNavigate = (link) => {
    navigate(link);
  };

  // const renderTree = (nodes) => {
  //   // console.log(nodes)
  //   return (
  //     <TreeItem
  //       key={nodes.id}
  //       nodeId={nodes.id}
  //       label={
  //         <Box
  //           sx={{
  //             display: "flex",
  //             alignItems: "flex-start",
  //             p: 1,
  //             gap: "0.6rem",
  //           }}
  //           onClick={() => {
  //             if (nodes.children === null) {
  //               if(nodes.module.toUpperCase()==="ASSETS_EXPL"){
  //                 dispatch({type:"drawerOpen",payload:{bol:true,open:false}})
  //               }else{
  //                 dispatch({type:"drawerOpen",payload:{bol:false,open:false}})
  //               }
  //               navigate(`${nodes.href}`);
  //               // dispatch({type:"actionsAllow",payload:nodes})
  //             }
  //           }}
  //         >
  //           <img
  //             src={`${nodes.icon}`}
  //             style={{
  //               width: "1.4rem",
  //               height: "1.4rem",
  //               display: nodes.children == null ? "default" : "none",
  //             }}
  //           />
  //           <Typography
  //             sx={{
  //               fontSize: "0.82rem",
  //               fontWeight: color.sideFontWeight,
  //               fontFamily: color.sideFontFamily,
  //               color: color.sideFontColor,
  //             }}
  //           >
  //             {nodes.name}
  //           </Typography>
  //         </Box>
  //       }
  //       sx={{ mt: 0.7, p: 0, ml:nodes.children === null? -3.5:0 }}
  //     >
  //       {Array.isArray(nodes.children)
  //         ? nodes.children.map((node) => renderTree(node))
  //         : null}
  //     </TreeItem>
  //   );
  // };

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={drawerOpen.bol ? drawerOpen.open : props.open}
      sx={{
        width: props.drawerWidth,
        flexShrink: 0,
        display: {
          xs: props.res === "main" ? "none" : "block",
          md: props.res === "main" ? "block" : "none",
        },
        [`& .MuiDrawer-paper`]: {
          width: props.drawerWidth,
          boxSizing: "border-box",
          border: "none",
          // backgroundColor: props.res === "main" ? "#FEDADA" : "default",
          background: "linear-gradient(to top, #FD0000 , #00807F)",
          // mt: { xs: props.res === "main" ? 0 : "7.5 vh", md: props.res === "main" ? 0 : "9vh" },
          // boxShadow: props.res === "main" ? 0 : 3,
          mt: { xs: props.res === "main" ? 0 : "7.5vh",sm: props.res === "main" ? 0 : "6.5vh" },
          boxShadow: `0px 2px 10px ${commonCss.red}`,
        },
      }}
    >
      <Toolbar
        sx={{ display: props.res === "main" ? "block" : "none" }}
      ></Toolbar>
      <Box sx={{ overflow: "auto" }}>
        <List
          sx={{
            width: "100%",
            // bgcolor: "background.paper",
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            mt: "1rem",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {menuList.map((item, i) =>
            !item.title ? (
              <MenuUI key={i} item={item} bg={currentPath === item.link} />
            ) : (
              <>
                <Typography
                  sx={{ p: 2, color: "whitesmoke", letterSpacing: 2 }}
                >
                  SETTING
                </Typography>
                {item.childMenu !== undefined &&
                  item?.childMenu.map((child, i) => (
                    <MenuUI
                      key={i}
                      item={child}
                      bg={currentPath === child.link}
                    />
                  ))}
              </>
            )
          )}

          {/* <ListItem sx={{background:currentPath==="/dashboard"?commonCss.yellow:"none",display:admin?"default":"none"}}>
            <Link to="/dashboard">
              <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                <Dashboard />
                <Typography>Dashboard</Typography>
              </Box>
            </Link>
          </ListItem>
          <ListItem sx={{display:getFormMenu.length===0?"none":"block",background:currentPath===`/formlist/${btoa(roleName)}`?commonCss.yellow:"none"}}>
            <Link to=`/formlist/${btoa(roleName)}`>
              <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                <ListAlt />
                <Typography>Form</Typography>
              </Box>
            </Link>
          </ListItem>
          <ListItem sx={{display:OEController?"block":"none",background:currentPath==="/controllerroom"?commonCss.yellow:"none"}}> 
            <Link to="/controllerroom">
              <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                <ListAlt />
                <Typography>Controller Room</Typography>
              </Box>
            </Link>
          </ListItem> */}

          {/* {psUser||admin?  <ListItem sx={{background:currentPath==="/activepermit"?commonCss.yellow:"none"}}>
            <Link to="/activepermit">
              <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                <ListAlt />
                <Typography>Active Permit</Typography>
              </Box>
            </Link>
          </ListItem>:null}
          {admin ? (
            <>
          
              <Typography sx={{ p: 2, color: "whitesmoke", letterSpacing: 2 }}>
                SETTING
              </Typography>
              <ListItem sx={{background:currentPath==="/user"?commonCss.yellow:"none"}}>
                <Link to="/user">
                  <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                    <Group />
                    <Typography>Users</Typography>
                  </Box>
                </Link>
              </ListItem>
              {psUser?
              <>
              <ListItem sx={{background:currentPath==="/terminal"?commonCss.yellow:"none"}}>
                <Link to="/terminal">
                  <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                    <DeveloperBoard />
                    <Typography>Terminal</Typography>
                  </Box>
                </Link>
              </ListItem>
              <ListItem sx={{background:currentPath==="/site"?commonCss.yellow:"none"}}>
                <Link to="/site">
                  <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                    <PinDrop />
                    <Typography>Site</Typography>
                  </Box>
                </Link>
              </ListItem>
              <ListItem sx={{background:currentPath==="/company"?commonCss.yellow:"none"}}>
                <Link to="/company">
                  <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                    <Business />
                    <Typography>Company</Typography>
                  </Box>
                </Link>
              </ListItem>
              <ListItem sx={{background:currentPath==="/emailtemplate"?commonCss.yellow:"none"}}>
                <Link to="/emailtemplate">
                  <Box sx={{ display: "flex", gap: "0.5rem", color: "white" }}>
                    <Business />
                    <Typography>Email Template</Typography>
                  </Box>
                </Link>
              </ListItem>
              </>
              :null}
            </>
          ) : null} */}
          {/* <ListItem>
          <Link to="/role" >
          <Box sx={{display:"flex",gap:"0.5rem",color:"white"}}>
            <AssignmentInd/>
          <Typography>
            Role
          </Typography>
          </Box>
          </Link>
        </ListItem> */}
        </List>
        {/* <TreeView
          aria-label="Location Tree"
          defaultCollapseIcon={<ExpandMoreIcon sx={{ color: "#828079" }} />}
          //  defaultExpanded={expanded}
          defaultExpandIcon={<ChevronRightIcon sx={{ color: "#828079" }} />}
          sx={{
            "& .MuiTreeItem-root": {
              "& .MuiTreeItem-content": {
                "& .MuiTreeItem-label": {
                  paddingLeft: "1em",
                },
                "& .MuiTreeItem-iconContainer": {
                  paddingLeft: "0.5em",
                },
              },
            },
          }}
        >
          {data.map((list, i) => (
            <Box key={i}>{renderTree(list)}</Box>
          ))}
        </TreeView> */}
      </Box>
    </Drawer>
  );
};

export default SideNav;
